import { useEffect, useRef, useState } from 'react';
import { QUERY_GET_PERSONS_OF_ENTITY } from 'services/aws/user-query';
import { useLazyQuery } from '@apollo/client';
import { sort, sortUsers } from 'utils/sort';
import Person from 'models/Person';
import { EntityTypes } from 'constants';
import { getFilteredUsers } from 'contexts/GroupsContext';

function useUserPool({ entityId }) {
  const personsPool = useRef([]);
  const [personPool, setPersonPool] = useState([]);
  const [getPool, { loading, error, data }] = useLazyQuery(
    QUERY_GET_PERSONS_OF_ENTITY,
    {
      variables: { entityId },
      fetchPolicy: 'network-only'
    }
  );

  useEffect(() => {
    if (data?.getPersonsOfEntity) {
      personsPool.current = sort(
        data.getPersonsOfEntity.map(person => new Person(person)),
        {
          keys: [{ key: 'firstname' }, { key: 'lastName' }]
        }
      );
      setPersonPool(personsPool.current);
    }
  }, [data]);

  const filterPool = filter => {
    const persons = personsPool.current;
    const filteredUsers =
      filter.type !== EntityTypes.GROUP
        ? getFilteredUsers(sortUsers(persons), filter.search ?? '')
        : [];

    // get a list of all users but not the ones that are in filteredUsers
    const usersNotInFilteredUsers = persons
      .filter(
        client =>
          !filteredUsers.some(filteredUser => filteredUser.id === client.id)
      )
      .map(user => new Person({ ...user, filtered: false }));

    setPersonPool([...filteredUsers, ...usersNotInFilteredUsers]);
  };

  return { loading, error, personPool, getPool, filterPool };
}

export default useUserPool;
